import "./assets/css/DesignSystem/DesignSystem.css";
import "./App.css";
import "./assets/css/font/fontStyles.css";
import { Route, Routes } from "react-router-dom";
import Signup from "./screens/user/auth/Signup/Signup.js";
import OrderInCustomer from "./components/user/Order/OrderInCustomer.js";
import CustomerRating from "./components/user/Order/Orderrating.js";
import SettingInCustomer from "./components/user/Setting/SettingInCustomer.js";
import SupportInCustomer from "./components/user/SupportInCustomer/SupportInCustomer.js";
import Home from "./screens/user/home/Home";
import AllDeals from "./screens/user/alldeals/AllDeals.js";
import CardDetailPage from "./screens/user/card/CardDetailPage.js";
import CartPage from "./screens/user/cart/CartPage.js";
import WishlistPage from "./screens/user/wishlist/WishlistPage.js";
import AdminDashboard from "./screens/admin/Dashboard/AdminDashboard.js";
import CategoriesInAdmin from "./screens/admin/Categories/CategoriesInAdmin.js";
import FAQsInAdmin from "./screens/admin/FAQs/FAQsInAdmin.js";
import NotificationsInSeller from "./screens/sellers/Notifications/NotificationsInSeller.js";
import NotificationsInAdmin from "./screens/admin/NotificationsInAdmin/NotificationsInAdmin.js";
import ShopManagementInAdmin from "./screens/admin/Shops/ShopManagementInAdmin.js";
import DealsInSeller from "./screens/sellers/deals/DealsInSeller.js";
import SellerCancelledOrders from "./screens/sellers/orders/SellerCancelledOrders.js";
import SellerCompletedOrders from "./screens/sellers/orders/SellerCompletedOrders.js";
import SellerOngoingOrders from "./screens/sellers/orders/SellerOngoingOrders.js";
import SettingInSeller from "./screens/sellers/setting/SettingInSeller.js";
import ChatPage from "./screens/sellers/supports/ChatPage.js";
import SupportsInSeller from "./screens/sellers/supports/SupportsInSeller.js";
import WalletInSeller from "./screens/sellers/wallet/WalletInSeller.js";
import Login from "./screens/user/auth/login/Login.js";
import Blogs from "./components/user/blogs/Blogs.js";
import Shops from "./components/user/shops/Shops.js";
import BlogsDetail from "./components/user/blogs/BlogDetailpage.js";
import AboutUs from "./screens/user/about/AboutUs.js";
import ContactUs from "./screens/user/contactus/ContactUs.js";
import Deals from "./screens/user/deals/Deals.js";
import TopCategories from "./components/topCategories/TopCategories";
import ContactPage from "./components/user/contactPage/ContactPage";
import FeaturedDeals from "./components/user/featuredDeals/FeaturedDeals";
import HowDealsWork from "./components/user/howDealsWork/HowDealsWork";
import WhyTime4Pulse from "./components/user/whytime4pulse/WhyTime4Pulse";
import SellerLogin from "./screens/sellers/auth/sellerLogin/SellerLogin.js";
import Sellersignup from "./screens/sellers/auth/sellersignup/Sellersignup.js";
import LatestBlog from "./screens/user/latestBlog/LatestBlog";
import SellerBanner from "./screens/user/sellerBanner/SellerBanner";
import Testimonials from "./screens/user/testimonials/Testimonials";
import TopRatedDeals from "./screens/user/topRatedDeals/TopRatedDeals";
import TopShops from "./screens/user/topShops/TopShops";
import MarqueeBanner from "./components/user/Marqueebanner/Marqueebanner.js";
import SettingInAdmin from "./screens/admin/setting/SettingInAdmin.js";
import SupportTicketInAdmin from "./screens/admin/supportticket/SupportTicketInAdmin.js";
import ChatpageInAdmin from "./screens/admin/supportticket/ChatpageInAdmin.js";
import MarqueeInAdmin from "./screens/admin/marqueeInAdmin/MarqueeInAdmin.js";
import BlogInAdmin from "./screens/admin/blogInAdmin/BlogInAdmin.js";
import PayoutRequestInAdmin from "./screens/admin/payout Request/PayoutRequestInAdmin.js";
import TopUpRequestInAdmin from "./screens/admin/topup request/TopUpRequestInAdmin.js";
import AdminLogin from "./screens/admin/auth/adminLogin/AdminLogin.js";
import OrdersInSeller from "./screens/sellers/orders/OrdersInseller.js";
import Notifications from "./components/user/notification/Notification.js";
import NotificationsPage from "./screens/user/notifications/NotificationsPage.js";
import Checkout from "./screens/user/cart/Checkout.js";
import SupportDisputes from "./screens/user/supportDisputes/SupportDisputes.js";
import SupportTickets from "./screens/user/supportTickets/SupportTickets.js";
import SupporttInCustomer from "./screens/user/supporttInCustomer/SupporttInCustomer.js";
// import SupportInCustomer from "./screens/user/supportInCustomer/SupportInCustomer.js";
import ChatInCustomer from "./screens/user/supportDisputes/ChatInCustomer.js";
import OrderDetail from "./components/user/Order/OrderDetail.js";
import SellerOrderDetail from "./screens/sellers/orders/SellerOrderDetail.js";
import ShopDetailPage from "./screens/user/shops/shopdetailpages/ShopDetailPage.js";
import TPshop from "./components/user/tpshop/Tpshop.js";
import PaymentSuccess from "./screens/user/payment/PaymentSuccess.js";
import PaymentCancel from "./screens/user/payment/PaymentCancel.js";
import DashboardInSeller from "./screens/sellers/dashboard/DashboardInSeller.js";
import DealDetails from "./components/user/card/dealCard/DealDetails.js";
import ProtectedRoute from "./components/user/ProtectedRoute/ProtectedRoute.js";
function App() {
  return (
    <>
      <Routes>
        {/* CUSTOMER ROUTES */}

        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/blog/detail/:id" element={<BlogsDetail />} />
        <Route path="/rate/:shopId/:orderId" element={<CustomerRating />} />
        <Route path="/blog" element={<Blogs />} />
        <Route path="/deal-details/:id" element={<DealDetails />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/all-deals" element={<AllDeals />} />
        <Route path="/marquee-banner" element={<MarqueeBanner />} />
        <Route path="/deal-detail" element={<CardDetailPage />} />
        <Route path="/cart" element={<CartPage />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/wishlist" element={<WishlistPage />} />
        <Route path="/notification" element={<Notifications />} />
        <Route path="/notification-page" element={<NotificationsPage />} />
        <Route path="/customer-setting" element={<SettingInCustomer />} />
        <Route path="/customer-orders" element={<OrderInCustomer />} />
        <Route path="*" element={<page not found />} />
        <Route path="/payment-success" element={<PaymentSuccess />} />
        <Route path="/payment-cancel" element={<PaymentCancel />} />
        {/* <Route path="/customer-supports" element={<SupportInCustomer />} /> */}
        <Route path="/support-disputes" element={<SupportDisputes />} />
        <Route path="/support-tickets" element={<SupportTickets />} />
        <Route path="/support-in-customer" element={<SupporttInCustomer />} />
        <Route path="/customer-chat/:id" element={<ChatInCustomer />} />
        <Route path="/order-detail" element={<OrderDetail />} />

        {/* SHOP ROUTES */}
        <Route path="/tpshop" element={<TPshop />} />
        <Route path="/shop" element={<Shops />} />
        <Route path="/shop/:id" element={<ShopDetailPage />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/deals" element={<Deals />} />
        <Route path="how-deals-work" element={<HowDealsWork />} />
        <Route path="why-time4-pulse" element={<WhyTime4Pulse />} />
        <Route path="featured-deals" element={<FeaturedDeals />} />
        <Route path="top-categories" element={<TopCategories />} />
        <Route path="contact-page" element={<ContactPage />} />
        <Route path="latest-blog" element={<LatestBlog />} />
        <Route path="testimonials" element={<Testimonials />} />
        <Route path="top-shops" element={<TopShops />} />
        <Route path="seller-banner" element={<SellerBanner />} />
        <Route path="top-rated-deals" element={<TopRatedDeals />} />
        {/* SELLER ROUTES */}
        <Route element={<ProtectedRoute role="seller" />}>
          <Route path="/seller-deals" element={<DealsInSeller />} />
          <Route
            path="/seller-notifications"
            element={<NotificationsInSeller />}
          />
          <Route path="/seller-orders" element={<OrdersInSeller />} />
          <Route path="/seller-dashboard" element={<DashboardInSeller />} />
          <Route path="/seller-order-detail" element={<SellerOrderDetail />} />
          <Route path="/seller-setting" element={<SettingInSeller />} />
          <Route path="/seller-supports" element={<SupportsInSeller />} />
          <Route path="/seller-wallet" element={<WalletInSeller />} />
          <Route path="/seller-chat/:ticketId" element={<ChatPage />} />
        </Route>
        <Route path="/seller-login" element={<SellerLogin />} />
        <Route path="/seller-signup" element={<Sellersignup />} />

        {/* ADMIN ROUTES */}
        <Route element={<ProtectedRoute role="admin" />}>
          <Route path="/admin-dashboard" element={<AdminDashboard />} />
          <Route path="/admin-shops" element={<ShopManagementInAdmin />} />
          <Route
            path="/admin-topup-requests"
            element={<TopUpRequestInAdmin />}
          />
          <Route path="/admin-categories" element={<CategoriesInAdmin />} />
          <Route
            path="/admin-payout-requests"
            element={<PayoutRequestInAdmin />}
          />
          <Route path="/admin-blogs" element={<BlogInAdmin />} />
          <Route path="/admin-faqs" element={<FAQsInAdmin />} />
          <Route path="/admin-marquee" element={<MarqueeInAdmin />} />
          <Route path="/admin-supports" element={<SupportTicketInAdmin />} />
          <Route
            path="/admin-support-ticket-chat/:id"
            element={<ChatpageInAdmin />}
          />
          <Route
            path="/admin-notifications"
            element={<NotificationsInAdmin />}
          />
          <Route path="/admin-setting" element={<SettingInAdmin />} />
        </Route>
        <Route path="/admin-login" element={<AdminLogin />} />
      </Routes>
    </>
  );
}

export default App;
